/* import __COLOCATED_TEMPLATE__ from './topic.hbs'; */
import Component from "@glimmer/component";
import { inject as service } from "@ember/service";

export default class Results extends Component {
  @service siteSettings;
}
